var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-action d-middle-bt gap-2",class:{'filtering': _vm.filtering},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"icon-filter f-20"}),_c('i',{staticClass:"icon-angle-down f-20"})])
}
var staticRenderFns = []

export { render, staticRenderFns }